import type { Ref } from 'vue';

import { resolveShortsLocationStatesForLabels } from '~/composables/useShortsFilters/resolveShortsLocationStates';
import { getLocationPlaceholder } from '~~/utils';
import { computed } from 'vue';

const LOCATION_LABEL_PREFIX = 'Busque lugares em ';

export interface ShortsLocationFilters {
	cities: Ref<string[]>;
	regions: Ref<string[]>;
	macroregions: Ref<string[]>;
	states: Ref<string[]>;
}

/**
 * Labels de localização dos filtros Shorts (barra / reel): uma única regra de estados
 * (`resolveShortsLocationStatesForLabels`) + `getLocationPlaceholder`.
 */
export function useShortsLabels(options: ShortsLocationFilters) {
	const { cities, regions, macroregions, states } = options;

	const resolvedStates = computed(() =>
		resolveShortsLocationStatesForLabels(macroregions.value, states.value)
	);

	const locationLabel = computed<string>(() => {
		const placeholder = getLocationPlaceholder({
			cities: cities.value,
			regions: regions.value,
			macroregions: macroregions.value,
			states: resolvedStates.value,
			includeRegion: true,
			separator: ', '
		});
		return placeholder ? `${LOCATION_LABEL_PREFIX}${placeholder}` : '';
	});

	/** Texto de seleção sem prefixo, formatado para exibição na barra de busca. */
	const selectionText = computed<string>(() =>
		getLocationPlaceholder({
			cities: cities.value,
			regions: regions.value,
			macroregions: macroregions.value,
			states: resolvedStates.value,
			includeRegion: true
		})
	);

	return { locationLabel, selectionText };
}
